<template>
  <div id="map" class="music-map">
    <div v-if="!markers">Loading: {{ data }}</div>
  </div>
</template>

<script>
import * as L from "../../node_modules/leaflet/dist/leaflet-src";
const cache = {};

export default {
  name: "MusicMap",
  props: ["markers", "geolocation", "lat", "lng", "fetchData", "zoom"],
  data: function() {
    return {
      cachedLat: undefined,
      cachedLng: undefined,
      cachedMap: undefined,
      latitude: 0,
      longitude: 0,
      cachedZoom: undefined,
      city: undefined
    };
  },

  mounted() {
    this.cachedLat = this.lat;
    this.cachedLng = this.lng;
    this.latitude = this.lat;
    this.longitude = this.lng;
  },

  updated() {
    const lat = this.lat || this.geolocation.latitude || 0;
    const lng = this.lng || this.geolocation.longitude || 0;

    // this.latitude = lat;
    // this.longitude = lng;
    if (this.cachedMap) {
      this.cachedMap.remove();
    }
    let map;
    this.zoom = this.zoom || 10;
    map = L.map("map");
    const markers = [];
    if (lat !== this.latitude || lng !== this.longitude) {
      map.setView([lat, lng], this.zoom, { animate: true });

      const icon = L.icon({
        iconUrl: "/genre_icons/marker_sm.svg"
      });
      var circle = L.circle([lat, lng], 125, {
        color: "#c53526",
        fillColor: "#c53526",
        fillOpacity: 0.15
      }).addTo(map);
      L.tileLayer(
        "http://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.{ext}",
        {
          attribution:
            'Map tiles by <a href="https://github.com/CartoDB/basemap-styles">Carto Dn</a>',
          subdomains: "abcd",
          minZoom: 0,
          maxZoom: 20,
          fadeAnimation: false,
          ext: "png"
        }
      ).addTo(map);
      map.scrollWheelZoom.disable();
      map.zoomControl.options.position = "topright";
      let combinedLocations = sortMarkers(this.markers);

      for (const p in combinedLocations) {
        if (
          combinedLocations &&
          combinedLocations[p] &&
          combinedLocations[p][0] &&
          combinedLocations[p][0].lat
        ) {
          const popup = L.popup({ autoPan: false });
          popup.setContent(`${combinedLocations[p].songsStr}`);

          markers.push(
            L.marker([p.split("_")[0], p.split("_")[1]], {
              icon
            }).bindPopup(popup)
          );
        }
      }
      markers.map(marker => marker.addTo(map));
      map.cachedLat = map.getCenter().lat;
      map.cachedLng = map.getCenter().lng;
      this.cachedMap = map;
    } else {
      return;
    }

    map.on("zoomend", e => {
      this.cachedZoom = e.target.getZoom();
    });

    map.on("moveend", e => {
      const location = e.target.getCenter();
      const lat = location.lat;
      const lng = location.lng;
      const zoom = e.target.getZoom();
      map.removeLayer(circle);
      // if (this.cachedZoom !== zoom) {
      //   return;
      // }
      // ensures that map doesn't redraw and refetch when there is a zoom change or subtle drag
      if (
        (map.cachedLat === lat ||
          Math.abs(Math.abs(map.cachedLat) - Math.abs(lat)) < 0.1 ||
          Math.abs(Math.abs(lat) - Math.abs(map.cachedLat)) < 0.1) &&
        (map.cachedLng === lng ||
          Math.abs(Math.abs(map.cachedLng) - Math.abs(lng)) < 0.1 ||
          Math.abs(Math.abs(lng) - Math.abs(map.cachedLng)) < 0.1)
      ) {
        return;
      }

      setTimeout(() => {
        // if (lat !== map.cachedLat) {
        if (!cache[lat] && !cache[lng]) {
          markers.map(marker => map.removeLayer(marker));
          this.$emit("fetchData", lat, lng);
          cache[lat] = lat;
          cache[lng] = lng;
        }
        // }
      }, 500);
    });
  }
};

function sortMarkers(data) {
  return data.reduce((accum, marker) => {
    if (marker) {
      const latLng = `${marker.lat}_${marker.lng}`;
      if (accum[latLng]) {
        accum[latLng].push(marker);
        accum[latLng].songsStr += `
        <div class="popup-artist-name">${marker.title}</div>
      `;
      } else {
        accum[latLng] = [];
        accum[latLng].songsStr = "";
        accum[latLng].songsStr += `
      <div class="popup-artist-name"${marker.title}</div>

    `;
        accum[latLng].push(marker);
      }
    }
    return accum;
  }, {});
}
</script>

<style>
#map.music-map {
  height: calc(100% - 9px);
}
.leaflet-popup-content {
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;
}

.leaflet-popup-content h4 {
  font-size: 0.9rem;
}

.popup-artist-name {
  padding-top: 8px;
}
</style>
